import styled from 'styled-components'

import { media } from 'styles/media'

import LazyImage from '../../../components/display/LazyImage'

import Overlay, { OVERLAY_Z_INDEX } from './Overlay'
import { PAGE_MAX_WIDTH } from './constants'

const Title = styled.h1`
  color: ${({ theme }) => theme['-ds-neutral-100'].value};
  font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-md']['font-weight'].value};
  margin-bottom: 0;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-xxl']['font-size'].value};
  `}
`

const Subtitle = styled.h3`
  color: ${({ theme }) => theme['-ds-neutral-100'].value};
  font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-sm']['font-weight'].value};
  margin-bottom: 16px;

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  `}
`

const Inner = styled.div`
  width: 100%;
  max-width: ${PAGE_MAX_WIDTH}px;
  margin-bottom: 40px;
  z-index: ${OVERLAY_Z_INDEX + 1};

  padding: 0 16px;
`

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${media.md`
    align-items: center;
    justify-content: center;
  `}

  position: relative;
  width: 100%;
  height: 66vh;

  ${LazyImage} {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
`

type HeaderProps = {
  name: string
  image: {
    thumb: string
    medium: string
    large: string
    hero: string
  }
}

const Header = ({ image, name }: HeaderProps) => {
  return (
    <Outer>
      <LazyImage
        data-src={image.large}
        data-srcset={`
          ${image.medium} 620w,
          ${image.large} 1200w,
          ${image.hero} 1300w,
        `}
        preload
      />
      <Overlay />
      <Inner>
        <Subtitle>Collection</Subtitle>
        <Title>{name}</Title>
      </Inner>
    </Outer>
  )
}

export default Header
